import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../config/apiConfig";

const SubscriptionHistory = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingIds, setLoadingIds] = useState([]);

  const userId = localStorage.getItem("user_id");

  const formatDate = (dateStr) => {
    const dateObj = new Date(dateStr);
    return dateObj.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  };

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    const fetchSubscriptions = async () => {
      try {
        const response = await fetch(`${BASE_URL}/mysubscriptions/${userId}`);
        const res = await response.json();

        if (res.status === 200) {
          const subs = res.data.map((sub) => ({
            ...sub,
            features: JSON.parse(sub.features),
          }));
          setSubscriptions(subs);
        } else {
          console.error("Error fetching subscriptions:", res.message);
        }
      } catch (error) {
        console.error("Error fetching subscriptions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptions();
  }, [userId]);

  const handleRenewalToggle = async (sub) => {
    const isEnabled = sub.renewal === "1"; // current status
    const actionUrl = isEnabled
      ? `${BASE_URL}/subscription/disable-renew/${sub.stripe_subscription_id}`
      : `${BASE_URL}/subscription/enable-renew/${sub.stripe_subscription_id}`;

    try {
      setLoadingIds((prev) => [...prev, sub.id]);

      const response = await fetch(actionUrl, { method: "POST" });
      const res = await response.json();

      if (res.status === 200) {
        // Toggle the renewal locally and flip button text
        setSubscriptions((prevSubs) =>
          prevSubs.map((s) =>
            s.id === sub.id
              ? { ...s, renewal: isEnabled ? "0" : "1" } // Update state
              : s
          )
        );
      } else {
        console.error("Error updating renewal:", res.message);
      }
    } catch (error) {
      console.error("API call failed:", error);
    } finally {
      setLoadingIds((prev) => prev.filter((id) => id !== sub.id));
    }
  };

  if (loading) {
    return <div className="text-center py-10 text-gray-600">Loading subscriptions...</div>;
  }

  if (!userId) {
    return <div className="text-center py-10 text-gray-600">User not logged in.</div>;
  }

  if (subscriptions.length === 0) {
    return <div className="text-center py-10 text-gray-600">No subscriptions found.</div>;
  }

  return (
    <div className="py-8 px-6 w-full max-w-4xl mx-auto">
      {subscriptions.map((sub) => (
        <div
          key={sub.id}
          className="bg-white rounded-xl shadow-md p-6 mb-6 flex justify-between items-center w-full"
        >
          {/* Left: Plan info */}
          <div>
            <h3 className="text-xl font-semibold text-gray-900 mb-1">{sub.title}</h3>
            <ul className="text-gray-700 text-sm mb-2 space-y-1">
              {sub.features.map((feature, idx) => (
                <li key={idx} className="flex items-center">
                  <span className="text-green-600 mr-2 select-none">✔</span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            {/* <p className="text-gray-600 text-sm mb-3">
              <span className="font-semibold">Start:</span> {formatDate(sub.start_date)} |{" "}
              <span className="font-semibold">End:</span> {formatDate(sub.end_date)}
            </p> */}
          </div>

          {/* Right: Price and status */}
          <div className="flex flex-col items-end space-y-3">
            <div className="text-2xl font-bold text-gray-900">${sub.total_amount}</div>
            <div className="text-gray-500 text-sm">per month</div>

            <button
              disabled
              className={`px-5 py-2 rounded-full font-semibold text-sm ${
                sub.status === "active"
                  ? "text-green-600 cursor-not-allowed"
                  : "text-red-600 cursor-not-allowed"
              }`}
            >
              {sub.status === "active" ? "Active" : "Expired"}
            </button>

            {sub.status === "active" && (
              <button
                onClick={() => handleRenewalToggle(sub)}
                disabled={loadingIds.includes(sub.id)}
                className={`px-5 py-2 rounded-full font-semibold text-sm transition-colors duration-200 ${
                  sub.renewal === "1"
                    ? "bg-green-600 text-white hover:bg-green-600"
                    : "bg-gray-300 text-gray-600 hover:bg-gray-400"
                }`}
              >
                {loadingIds.includes(sub.id)
                  ? "Processing..."
                  : sub.renewal === "1"
                  ? "Disable Renewal"
                  : "Enable Renewal"}
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SubscriptionHistory;
